const fr = {
  brand: "Audace & Perspectives",
  tagline: "Mettons votre audace en action",
  nav: {
    home: "Accueil",
    about: "À propos",
    coaches: "Équipe",
    coaching: "Executive coaching",
    outplacement: "Outplacement",
    team: "Coaching d'équipe",
    corporate: "Formation",
    formation: "Formation",
    resources: "Ressources",
    contact: "Contact",
    login: "Espace confidentiel",
    dashboard: "Mon espace",
    logout: "Déconnexion",
    menu: "Menu",
    close: "Fermer",
    offers: "Offres",
  },
  home: {
    eyebrow: "Executive coaching · Paris",
    title_a: "Mettons votre",
    title_b: "audace",
    title_c: "en action…",
    intro:
      "Nous accompagnons dirigeants et cadres dans leurs transitions de carrière, leurs prises de fonction et leurs transformations. Une approche sur mesure, ancrée dans la lucidité, l'audace et la singularité de chacun.",
    cta_primary: "Prendre contact",
    cta_secondary: "Découvrir nos offres",
    clients_eyebrow: "Ils nous font confiance",
    testimonials_eyebrow: "Ils témoignent",
    clients: ["Equans", "Faurecia", "Arkema", "Leo Pharma", "AstraZeneca", "Ingenico", "KPMG", "Sodexo", "Pronades", "IE XEG"],
    services: {
      individual: { title: "Executive coaching", desc: "Une prise de recul stratégique dans un dialogue exigeant, confidentiel, orienté résultats." },
      outplacement: { title: "Outplacement", desc: "Transformer une transition subie en projet choisi. Bilan, stratégie, réseau, intégration." },
      team: { title: "Coaching d'équipe", desc: "Créer l'alchimie d'un comité de direction et révéler l'intelligence collective." },
      formation: { title: "Formation", desc: "Programmes sur-mesure pour activer les compétences managériales et préparer les passages d'altitude." },
    },
    manifesto_title: "Notre conviction",
    manifesto_body:
      "Une période de transition est un moteur puissant pour se poser les bonnes questions, avoir des idées nouvelles et choisir une trajectoire qui nous ressemble. Nous croyons à la reconnaissance des talents, à la canalisation des valeurs profondes, et à la responsabilité de chacun comme acteur de sa réussite.",
    adn_eyebrow: "Notre ADN",
    adn_title: "Ce qui nous distingue.",
    adn_intro: "Cinq marqueurs qui guident chacun de nos accompagnements et fondent notre relation aux dirigeants que nous suivons.",
    adn_items: [
      "Notre écoute, notre curiosité positive et notre questionnement pertinent.",
      "Notre aptitude à donner du temps au temps, en fonction de votre situation et de vos besoins.",
      "Notre réactivité, notre efficacité et pragmatisme, notre engagement au service de vos enjeux.",
      "Notre réseau multi-sectoriel et notre volonté de vous en faire bénéficier.",
      "Notre expérience et notre culture internationales.",
    ],
    signature_title: "Nous nous définissons comme des orfèvres de l'accompagnement.",
    signature_body: "Plus de vingt ans au service des cadres dirigeants en s'appuyant sur un ancrage solide et un réseau actif.",
    final_title: "Prêt à vous mettre en mouvement ?",
    final_cta: "Nous vous offrons un premier entretien",
  },
  about: {
    eyebrow: "À propos",
    title: "Les orfèvres de l'accompagnement.",
    p1: "Audace & Perspectives accompagne dirigeants et cadres supérieurs à clarifier leurs objectifs professionnels, déployer leur singularité et choisir une trajectoire alignée avec leurs valeurs.",
    p2: "Nous savons que vous allez retrouver une activité qui répond à vos aspirations profondes. Nous apportons méthode et pragmatisme pour vous y conduire — dans le rythme qui est le vôtre.",
    values_title: "Nos valeurs",
    values: [
      { t: "Engagement", d: "Au service de vos enjeux, avec réactivité et constance." },
      { t: "Authenticité", d: "Travailler en partenariat, en confiance." },
      { t: "Audace", d: "Oser nommer, oser bouger, oser choisir." },
      { t: "Humilité", d: "Respecter votre intelligence du terrain." },
    ],
    convictions_title: "Notre conviction",
    convictions_body:
      "La canalisation de ce qui fait sens pour vous, l'ancrage dans vos valeurs profondes, et la reconnaissance de vos talents constituent la condition de la réussite. Une période de transition est l'opportunité de se poser les bonnes questions et d'opérer un changement choisi.",
  },
  coaching: {
    eyebrow: "Executive coaching",
    title: "Décider, manager, embarquer.",
    sections: [
      {
        t: "Vos constats",
        items: [
          "Votre environnement professionnel est de plus en plus complexe et changeant.",
          "Vous ne prenez pas le temps et le recul nécessaire pour penser, analyser et décider de la mise en place de comportements appropriés aux situations.",
        ],
      },
      {
        t: "Vos objectifs",
        items: [
          "Vous adapter à un nouveau contexte professionnel ou de nouvelles responsabilités.",
          "Améliorer votre confiance en vous, votre communication.",
          "Développer votre puissance managériale : la conquérir, la développer, développer votre écoute, votre relation à autrui, votre assertivité. Optimiser votre style de management en fonction de la culture de votre entreprise.",
          "Prendre de la hauteur et décider.",
          "Surmonter une difficulté ou un blocage, clarifier et dépasser un conflit, sortir d'une problématique récurrente.",
        ],
      },
      {
        t: "Notre raison d'être",
        items: [
          "Découvrir avec vous votre potentiel et en favoriser le déploiement.",
          "Caractériser et mettre en lumière vos objectifs professionnels.",
          "Vous mettre en mouvement au service des changements souhaités.",
        ],
      },
      {
        t: "Notre conviction",
        items: [
          "Chacun a la capacité de changer et peut grandir : nous sommes sujet de croissance et acteur de notre développement.",
          "Chacun a la capacité de penser par lui-même.",
          "Chaque personne est unique et il lui appartient de découvrir et exploiter ses éléments différenciants.",
          "La réussite d'un coaching dépend de l'alchimie entre le coach et son client.",
        ],
      },
      {
        t: "Notre méthode",
        items: [
          "Nous travaillons dans un esprit de partenariat avec nos clients.",
          "Notre méthodologie est innovante, nous avons une approche dynamique et globale des problèmes.",
          "Nous travaillons sur le concret et chaque rencontre vous amènera à adopter des comportements nouveaux choisis à partir de votre référentiel préféré.",
        ],
      },
    ],
  },
  outplacement: {
    eyebrow: "Outplacement",
    title: "Du changement subi au changement choisi.",
    sections: [
      {
        t: "Vos constats",
        items: [
          "Vous êtes dans une impasse au sein de votre entreprise, désarmé et en situation d'inconfort. Vous avez détecté certains signaux faibles, signes avant-coureurs d'une éviction possible.",
          "Vous avez besoin d'échanger avec l'extérieur : quitter ou continuer différemment ?",
          "Vous souhaitez prendre du recul et vous adjoindre l'aide d'un coach.",
          "Vous avez besoin de retrouver un rythme et structurer votre démarche.",
          "Vous avez peut-être adopté certains réflexes qui se sont avérés contre-productifs.",
        ],
      },
      {
        t: "Vos enjeux",
        items: [
          "Être aligné et cohérent avec vos valeurs et aspirations réelles.",
          "Vous réapproprier votre singularité et faire le point sur vos motivations et savoir-faire.",
          "Mettre de la clarté dans votre objectif professionnel et profiter de cette période pour amorcer un changement qui vous ressemble vraiment.",
          "Structurer votre démarche et votre discours.",
          "Vous positionner dans les meilleures conditions et délais.",
        ],
      },
      {
        t: "Notre raison d'être",
        items: [
          "Vous accompagner à déployer votre vie et retrouver vos moteurs d'intérêt et de plaisir.",
          "Vous faire bouger et vous permettre de reprendre confiance, de ressaisir votre force et mettre votre audace en mouvement pour réussir.",
          "Vous aider à restaurer une énergie positive et à devenir l'artisan de votre réussite par la conception d'un projet professionnel qualitatif, stimulant et réaliste.",
          "En tant que conseil de confiance, transformer votre transition de carrière en succès et passer d'un changement subi à un changement choisi.",
        ],
      },
      {
        t: "Notre conviction",
        items: [
          "Une période de transition est une excellente opportunité et un moteur puissant pour vous poser les bonnes questions, avoir des idées nouvelles et pour changer.",
          "La perte de repères qu'elle provoque requiert une énergie importante : il est essentiel d'aller au bout de chaque questionnement pour les arbitrages et décisions que vous aurez à prendre. Vous serez plus fort et plus efficace en étant accompagné et soutenu dans vos démarches.",
          "Retrouver une relation de confiance vous remet dans un cercle vertueux : la valorisation de vos talents vous amènera naturellement à la réussite.",
          "La canalisation de ce qui fait sens pour vous et de vos valeurs profondes vous donnera la force et l'audace d'agir.",
          "La reconnaissance de vos talents constitue la condition de la réussite.",
        ],
      },
      {
        t: "Notre méthode",
        items: [
          "Vous permettre de redevenir acteur de votre carrière. Par une réflexion approfondie sur votre personnalité et vos forces, propice aux idées nouvelles, nous vous aidons à trouver le mot juste.",
          "Trouver la solution, définir votre offre différenciante à partir de vos compétences et réalisations singulières.",
          "Concevoir, maîtriser et déployer vos outils marketing et communication : pitch percutant, discours musclé, identité numérique limpide, courriers ciblés incisifs.",
          "Définir ensemble votre meilleure stratégie, structurer votre démarche et focaliser vos énergies pour aller à la conquête de votre réalisation.",
          "Constituer, développer et utiliser efficacement votre réseau professionnel.",
          "Faire de cette période une opportunité de développement, de rencontres, de rebondissements qui vous mettront en joie.",
          "Sécuriser votre future prise de poste par un coaching d'intégration pendant votre période d'essai.",
        ],
      },
    ],
  },
  team: {
    eyebrow: "Coaching d'équipe",
    title: "L'alchimie du collectif.",
    intro:
      "Vous disposez de personnalités fortes et souhaitez créer du liant. Vous ambitionnez de vous appuyer sur l'intelligence collective pour relever des défis stratégiques.",
    objectives_title: "Vos objectifs",
    objectives: [
      "Relever de nouveaux défis stratégiques",
      "Mettre en place un cadre de fonctionnement responsable et engagé",
      "Insuffler du sens, raison d'être, valeurs",
      "Renforcer la cohésion et mobiliser les énergies",
    ],
    method_title: "Notre méthode",
    method_body:
      "Pragmatique et orientée résultats. Nous concevons des dispositifs sur mesure associant les objectifs du commanditaire et les besoins de l'équipe. Confidentialité, parole libre, indépendance des coachs.",
    codev_title: "Le co-développement",
    codev_body:
      "Groupes de 8 à 10 pairs, sur 10 sessions collectives de 3h, à raison d'une rencontre par mois. 6 étapes structurées : présentation, clarification, consultation, synthèse, plan d'action, apprentissage.",
  },
  corporate: {
    eyebrow: "Formation",
    title: "Au service de vos talents stratégiques.",
    intro:
      "Pour les DRH et les comités de direction, nous concevons des dispositifs sur mesure : coaching à la prise de poste, accompagnement des hauts potentiels, soutien aux dirigeants en transition.",
    offers_title: "Nos formats",
    offers: [
      { t: "Coaching Amplitude", d: "Prise de poste. 10h sur 3 à 4 mois." },
      { t: "Executive coaching classique", d: "Accompagnement dirigeant. 20h sur 4 à 6 mois." },
      { t: "Outplacement", d: "Transition de carrière. 6 / 12 / illimité." },
      { t: "Formation", d: "Programmes sur-mesure pour activer les compétences managériales." },
    ],
    network_title: "Notre écosystème",
    network_body:
      "Réseau santé/chimie, industrie/automobile, partenariats IENA (France et international), réseau chasse de têtes, DRH, cadres dirigeants, équipe du Mont Thabor, abonnement Les Échos 6 mois.",
    ethics_title: "Code éthique",
    ethics_body:
      "Nos interventions respectent le code d'éthique de la SF Coach. Confidentialité absolue sur toutes les informations recueillies au cours de la mission.",
  },
  contact: {
    eyebrow: "Contact",
    title: "Faisons connaissance…",
    intro:
      "Un projet, une question, un besoin d'échange confidentiel ? Nous vous répondons sous 48 heures ouvrées.",
    name: "Nom complet",
    email: "Email",
    phone: "Téléphone",
    company: "Société",
    topic: "Sujet",
    topics: { executive: "Executive Coaching", team: "Coaching d'équipe", formation: "Formation", outplacement: "Outplacement", partenariat: "Partenariat", pse: "PSE", other: "Autre" },
    message: "Votre message",
    send: "Envoyer le message",
    success: "Merci, votre message est bien parti. Nous revenons rapidement vers vous.",
    error: "Une erreur est survenue. Merci de réessayer.",
    address: "78 avenue des Champs-Élysées, 75008 Paris",
    phone_val: "+33 (0)6 52 30 30 00",
  },
  auth: {
    welcome: "Bienvenue",
    title: "Espace confidentiel",
    subtitle: "Connectez-vous pour accéder à vos tests, sessions et documents.",
    email: "Email",
    password: "Mot de passe",
    submit: "Se connecter",
    error: "Identifiants incorrects.",
    forgot: "Mot de passe oublié ?",
    forgot_title: "Mot de passe oublié",
    forgot_sub: "Saisissez votre email, nous vous enverrons un lien de réinitialisation.",
    forgot_submit: "Envoyer le lien",
    forgot_done: "Si l'adresse existe, un email vient d'être envoyé.",
    reset_title: "Nouveau mot de passe",
    reset_sub: "Choisissez un mot de passe sécurisé (8 caractères minimum).",
    reset_submit: "Définir le mot de passe",
    reset_done: "Mot de passe mis à jour. Vous pouvez vous connecter.",
    new_password: "Nouveau mot de passe",
    confirm_password: "Confirmer le mot de passe",
    mismatch: "Les mots de passe ne correspondent pas.",
    change_title: "Changement de mot de passe requis",
    change_sub: "Pour des raisons de sécurité, veuillez définir votre mot de passe personnel avant de continuer.",
    current_password: "Mot de passe actuel",
    change_submit: "Mettre à jour",
    change_done: "Mot de passe mis à jour.",
    back: "Retour à la connexion",
  },
  dashboard: {
    welcome: "Bonjour",
    summary: "Aperçu de votre accompagnement",
    nav: { overview: "Tableau de bord", tests: "Mes tests", sessions: "Sessions", objectives: "Objectifs", documents: "Documents", admin: "Administration", settings: "Paramètres" },
    stats: {
      tests_pending: "Tests à compléter",
      tests_completed: "Tests réalisés",
      sessions_upcoming: "Sessions à venir",
      objectives_in_progress: "Objectifs en cours",
      progression: "Progression",
    },
    next_session: "Prochaine séance",
    no_session: "Aucune séance planifiée",
    take_test: "Commencer le test",
    review_test: "Consulter les résultats",
    upload_doc: "Ajouter un document",
    new_objective: "Nouvel objectif",
    progress: "Progression",
    save: "Enregistrer",
    cancel: "Annuler",
    delete: "Supprimer",
    submit_test: "Soumettre le test",
    test_completed: "Test complété",
    result_level: "Niveau",
    result_score: "Score moyen",
    confidential: "Espace strictement confidentiel.",
  },
  admin: {
    title: "Administration",
    coachees: "Coachés",
    messages: "Messages",
    assign: "Assigner un test",
    add_coachee: "Ajouter un coaché",
    name: "Nom",
    program: "Programme",
    test: "Test",
    schedule_session: "Planifier une séance",
    session_title: "Intitulé",
    starts_at: "Date / heure",
    duration: "Durée (min)",
    location: "Lieu",
    notes: "Notes",
  },
  footer: {
    address: "78 avenue des Champs-Élysées, 75008 Paris",
    rights: "Tous droits réservés.",
    cta: "Mettons votre audace en action…",
  },
  team_page: {
    eyebrow: "Équipe",
    title: "",
    intro: "Un accompagnement exigeant, confidentiel, sur mesure — porté par la conviction que chaque dirigeant mérite la lucidité, le cap et l'élan qui lui appartiennent.",
    credentials: "Formation",
    languages: "Langues",
    cta_title: "Faisons connaissance…",
  },
};

const en = {
  brand: "Audace & Perspectives",
  tagline: "Put your audacity into motion",
  nav: {
    home: "Home",
    about: "About",
    coaches: "Team",
    coaching: "Executive coaching",
    outplacement: "Outplacement",
    team: "Team coaching",
    corporate: "Training",
    formation: "Training",
    resources: "Resources",
    contact: "Contact",
    login: "Confidential area",
    dashboard: "My space",
    logout: "Sign out",
    menu: "Menu",
    close: "Close",
    offers: "Offers",
  },
  home: {
    eyebrow: "Executive coaching · Paris",
    title_a: "Let's put your",
    title_b: "audacity",
    title_c: "into motion…",
    intro:
      "We accompany executives and senior leaders through career transitions, role onboardings, and transformations. A tailor-made approach grounded in lucidity, audacity, and singular respect for who you are.",
    cta_primary: "Get in touch",
    cta_secondary: "Discover our offers",
    clients_eyebrow: "Trusted by",
    testimonials_eyebrow: "What they say",
    clients: ["Equans", "Faurecia", "Arkema", "Leo Pharma", "AstraZeneca", "Ingenico", "KPMG", "Sodexo", "Pronades", "IE XEG"],
    services: {
      individual: { title: "Executive coaching", desc: "Strategic perspective through a demanding, confidential and results-oriented dialogue." },
      outplacement: { title: "Outplacement", desc: "Turning an imposed transition into a chosen project. Assessment, strategy, network, integration." },
      team: { title: "Team coaching", desc: "Building the chemistry of an executive committee and unlocking collective intelligence." },
      formation: { title: "Training", desc: "Tailor-made programmes to activate managerial competencies and prepare altitude shifts." },
    },
    manifesto_title: "Our conviction",
    manifesto_body:
      "A transition period is a powerful engine to ask the right questions, generate new ideas, and choose a path that truly resonates. We believe in the recognition of talents, the channelling of deep values, and personal responsibility as the engine of success.",
    adn_eyebrow: "Our DNA",
    adn_title: "What sets us apart.",
    adn_intro: "Five markers that guide each engagement and shape our relationship with the executives we accompany.",
    adn_items: [
      "Our listening, our positive curiosity, and our pertinent questioning.",
      "Our ability to give time to time, depending on your situation and needs.",
      "Our responsiveness, efficiency and pragmatism, our commitment to your stakes.",
      "Our multi-sector network and our willingness to make it available to you.",
      "Our international experience and culture.",
    ],
    signature_title: "We see ourselves as goldsmiths of accompaniment.",
    signature_body: "More than twenty years serving senior executives, supported by a solid anchorage and an active network.",
    final_title: "Ready to set yourself in motion?",
    final_cta: "We offer you a first conversation",
  },
  about: {
    eyebrow: "About",
    title: "The craftspeople of accompaniment.",
    p1: "Audace & Perspectives accompanies executives and senior leaders to clarify their professional objectives, deploy their singularity, and choose a path aligned with their values.",
    p2: "We know you will reach an activity that meets your deepest aspirations. We bring method and pragmatism — at the pace that is yours.",
    values_title: "Our values",
    values: [
      { t: "Engagement", d: "At the service of your priorities, with responsiveness and consistency." },
      { t: "Authenticity", d: "Working in trusted partnership." },
      { t: "Audacity", d: "Daring to name, to move, to choose." },
      { t: "Humility", d: "Respecting your field intelligence." },
    ],
    convictions_title: "Our conviction",
    convictions_body:
      "Channelling what matters to you, anchoring in your deep values, and recognising your talents are the conditions for success. A transition period is an opportunity to ask the right questions and to operate a chosen change.",
  },
  coaching: {
    eyebrow: "Executive coaching",
    title: "Deciding, leading, embarking your teams.",
    sections: [
      {
        t: "Your situation",
        items: [
          "Your professional environment is becoming increasingly complex and changing.",
          "You don't take the time and step back needed to think, analyse, and decide on appropriate behaviours for each situation.",
        ],
      },
      {
        t: "Your objectives",
        items: [
          "Adapt to a new professional context or new responsibilities.",
          "Improve your self-confidence and communication.",
          "Develop your managerial power: conquer it, grow it, develop your listening, your relationship with others, your assertiveness. Optimise your management style to fit your company's culture.",
          "Take altitude and decide.",
          "Overcome a difficulty or a deadlock, clarify and move beyond a conflict, exit a recurring problem.",
        ],
      },
      {
        t: "Our raison d'être",
        items: [
          "Discover your potential with you and foster its deployment.",
          "Characterise and bring to light your professional objectives.",
          "Set you in motion to serve the changes you want.",
        ],
      },
      {
        t: "Our conviction",
        items: [
          "Everyone can change and grow: we are subjects of growth and agents of our own development.",
          "Everyone has the capacity to think for themselves.",
          "Each person is unique — it is their responsibility to discover and leverage what makes them different.",
          "The success of coaching depends on the alchemy between the coach and the client.",
        ],
      },
      {
        t: "Our method",
        items: [
          "We work in a spirit of partnership with our clients.",
          "Our methodology is innovative; we take a dynamic and global approach to problems.",
          "We work on concrete reality and each session will lead you to adopt new behaviours chosen from your preferred reference framework.",
        ],
      },
    ],
  },
  outplacement: {
    eyebrow: "Outplacement",
    title: "From imposed change to chosen change.",
    sections: [
      {
        t: "Your situation",
        items: [
          "You are at a dead end within your company, unarmed and in a position of discomfort. You have detected weak signals — early signs of a possible ousting.",
          "You need to exchange with the outside: leave, or continue differently?",
          "You want to take a step back and bring in the help of a coach.",
          "You need to find a rhythm again and structure your approach.",
          "You may have adopted some reflexes that have proven counter-productive.",
        ],
      },
      {
        t: "Your stakes",
        items: [
          "Being aligned and consistent with your values and true aspirations.",
          "Reclaiming your singularity and taking stock of your motivations and know-how.",
          "Bringing clarity to your professional objective and taking advantage of this period to initiate a change that truly resembles you.",
          "Structuring your approach and your discourse.",
          "Positioning yourself in the best conditions and timeframes.",
        ],
      },
      {
        t: "Our raison d'être",
        items: [
          "Accompanying you in deploying your life and rediscovering your drivers of interest and pleasure.",
          "Getting you moving and allowing you to regain confidence, to seize back your strength and set your audacity in motion to succeed.",
          "Helping you restore positive energy and become the architect of your success through the design of a qualitative, stimulating, realistic professional project.",
          "As a trusted advisor, turning your career transition into success and moving from imposed change to chosen change.",
        ],
      },
      {
        t: "Our conviction",
        items: [
          "A transition period is an excellent opportunity and a powerful driver to ask yourself the right questions, have new ideas, and to change.",
          "The loss of bearings it provokes requires significant energy — it is essential to go to the end of each question for the arbitrations and decisions you will need to make. You will be stronger and more effective when accompanied and supported in your steps.",
          "Restoring a relationship of trust puts you back in a virtuous circle: valuing your talents will naturally lead you to success.",
          "Channelling what makes sense to you and your deep values will give you the strength and audacity to act.",
          "Recognising your talents is the condition for success.",
        ],
      },
      {
        t: "Our method",
        items: [
          "Allowing you to become an actor of your career again. Through deep reflection on your personality and your strengths, conducive to new ideas, we help you find the right words.",
          "Find the solution, define your differentiating offer based on your singular skills and achievements.",
          "Design, master, and deploy your marketing and communication tools: punchy pitch, robust discourse, clear digital identity, incisive targeted letters.",
          "Define together your best strategy, structure your approach, and focus your energies to conquer your realisation.",
          "Build, develop, and use your professional network effectively.",
          "Make this period an opportunity for development, encounters, and rebounds that will bring you joy.",
          "Secure your future onboarding through an integration coaching during your trial period.",
        ],
      },
    ],
  },
  team: {
    eyebrow: "Team coaching",
    title: "The chemistry of the collective.",
    intro:
      "You have strong personalities and want to create connection. You aspire to leverage collective intelligence to address strategic challenges.",
    objectives_title: "Your objectives",
    objectives: [
      "Take on new strategic challenges",
      "Set a responsible, engaged operating framework",
      "Infuse meaning, purpose, values",
      "Strengthen cohesion and mobilize energies",
    ],
    method_title: "Our method",
    method_body:
      "Pragmatic and results-oriented. We design tailored programs combining the sponsor's objectives and the team's needs. Confidentiality, free speech, independence of the coaches.",
    codev_title: "Co-development",
    codev_body:
      "Peer groups of 8 to 10, across 10 collective sessions of 3h, monthly. 6 structured steps: presentation, clarification, consultation, synthesis, action plan, learning.",
  },
  corporate: {
    eyebrow: "Training",
    title: "At the service of your strategic talents.",
    intro:
      "For HR leaders and executive committees, we design tailored programs: onboarding coaching, high-potential support, executive transition.",
    offers_title: "Our formats",
    offers: [
      { t: "Amplitude coaching", d: "Onboarding. 10h over 3 to 4 months." },
      { t: "Classic executive coaching", d: "Executive support. 20h over 4 to 6 months." },
      { t: "Outplacement", d: "Career transition. 6 / 12 / unlimited." },
      { t: "Training", d: "Tailor-made programmes to activate managerial competencies." },
    ],
    network_title: "Our ecosystem",
    network_body:
      "Health/chemistry network, industry/automotive, IENA partnerships (France and international), headhunters network, HR Directors, executives, Mont Thabor team, Les Échos 6-month subscription.",
    ethics_title: "Code of ethics",
    ethics_body:
      "Our interventions follow the SF Coach code of ethics. Absolute confidentiality on all information collected during the mission.",
  },
  contact: {
    eyebrow: "Contact",
    title: "Let's get acquainted…",
    intro: "A project, a question, a need for a confidential exchange? We respond within 48 business hours.",
    name: "Full name",
    email: "Email",
    phone: "Phone",
    company: "Company",
    topic: "Topic",
    topics: { executive: "Executive Coaching", team: "Team coaching", formation: "Training", outplacement: "Outplacement", partenariat: "Partnership", pse: "Job Protection Plan", other: "Other" },
    message: "Your message",
    send: "Send message",
    success: "Thank you, your message has been sent. We will reply shortly.",
    error: "An error occurred. Please try again.",
    address: "78 avenue des Champs-Élysées, 75008 Paris",
    phone_val: "+33 (0)6 52 30 30 00",
  },
  auth: {
    welcome: "Welcome",
    title: "Confidential area",
    subtitle: "Sign in to access your tests, sessions and documents.",
    email: "Email",
    password: "Password",
    submit: "Sign in",
    error: "Invalid credentials.",
    forgot: "Forgot password?",
    forgot_title: "Forgot password",
    forgot_sub: "Enter your email, we'll send you a reset link.",
    forgot_submit: "Send link",
    forgot_done: "If the address exists, an email has been sent.",
    reset_title: "New password",
    reset_sub: "Choose a secure password (minimum 8 characters).",
    reset_submit: "Set password",
    reset_done: "Password updated. You can now sign in.",
    new_password: "New password",
    confirm_password: "Confirm password",
    mismatch: "Passwords do not match.",
    change_title: "Password change required",
    change_sub: "For security reasons, please set your personal password before continuing.",
    current_password: "Current password",
    change_submit: "Update",
    change_done: "Password updated.",
    back: "Back to sign in",
  },
  dashboard: {
    welcome: "Hello",
    summary: "Your accompaniment at a glance",
    nav: { overview: "Overview", tests: "My tests", sessions: "Sessions", objectives: "Objectives", documents: "Documents", admin: "Admin", settings: "Settings" },
    stats: {
      tests_pending: "Pending tests",
      tests_completed: "Completed tests",
      sessions_upcoming: "Upcoming sessions",
      objectives_in_progress: "Objectives in progress",
      progression: "Progress",
    },
    next_session: "Next session",
    no_session: "No upcoming session",
    take_test: "Start test",
    review_test: "View results",
    upload_doc: "Add document",
    new_objective: "New objective",
    progress: "Progress",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    submit_test: "Submit test",
    test_completed: "Test completed",
    result_level: "Level",
    result_score: "Average score",
    confidential: "Strictly confidential space.",
  },
  admin: {
    title: "Administration",
    coachees: "Coachees",
    messages: "Messages",
    assign: "Assign a test",
    add_coachee: "Add a coachee",
    name: "Name",
    program: "Program",
    test: "Test",
    schedule_session: "Schedule a session",
    session_title: "Title",
    starts_at: "Date / time",
    duration: "Duration (min)",
    location: "Location",
    notes: "Notes",
  },
  footer: {
    address: "78 avenue des Champs-Élysées, 75008 Paris",
    rights: "All rights reserved.",
    cta: "Put your audacity into motion…",
  },
  team_page: {
    eyebrow: "The team",
    title: "",
    intro: "A demanding, confidential, tailor-made accompaniment — carried by the conviction that every leader deserves the lucidity, the course, and the momentum that belong to them.",
    credentials: "Education",
    languages: "Languages",
    cta_title: "Let's get to know each other…",
  },
};

export const translations = { fr, en };
